import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from '../../../../core/services/app.layout.service';
import { CommonModule } from '@angular/common';
import { RouterModule} from '@angular/router';
import {UserService} from '../../../../core/services/user.service';
import {TooltipModule} from 'primeng/tooltip';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {SplitButtonModule} from 'primeng/splitbutton';
import {MenuModule} from 'primeng/menu';

@Component({
  selector: 'pegasus-topbar',
  standalone: true,
  templateUrl: './top-bar.component.html',
  imports: [CommonModule, RouterModule, TooltipModule, ButtonModule, ToastModule, SplitButtonModule, MenuModule]
})
export class TopBarComponent {
  items!: MenuItem[];
  userActions = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {
        this.logout();
      }
    }
  ];
  @ViewChild('menuButton') menuButton!: ElementRef;
  @ViewChild('topBarMenuButton') topbarMenuButton!: ElementRef;
  @ViewChild('topBarMenu') menu!: ElementRef;

  user = this.userService.user;

  constructor(public layoutService: LayoutService, private userService: UserService) {

  }

  logout() {
    this.userService.logout();
  }
}
